import { collectionEngineV1 } from '../apis';
const customersAPI = collectionEngineV1('/customers');
export const getByReferenceId = (creditorId, referenceId) => customersAPI('GET', `/by-reference-id/${referenceId}?creditorId=${creditorId}`);
export const getById = (customerId, casualConsistency) => customersAPI('GET', `/${customerId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const create = (creditorId, newCustomer) => customersAPI('POST', `/?${new URLSearchParams({ creditorId: creditorId })}`, {
    body: newCustomer,
});
export const patchUser = (customerId, userId, edit) => customersAPI('PATCH', `/${customerId}/users/${userId}`, {
    body: edit,
});
export const addEventToUser = (customerId, userId, event) => customersAPI('POST', `/${customerId}/users/${userId}/add-event`, {
    body: event,
});
export const patch = (customerId, edit) => customersAPI('PATCH', `/${customerId}`, {
    body: edit,
});
export const requestInformationChange = (customerId, userId, caseId, data) => customersAPI('POST', `/${customerId}/${userId}/cases/${caseId}/request`, {
    body: data,
});
export const updateBankAccount = (customerId, bankAccount) => customersAPI('POST', `/${customerId}/bank-account`, {
    body: { bankAccount },
});
export const findPendingOverpayments = (customerId) => customersAPI('GET', `/${customerId}/pending-overpayments`);
export const getRelatedCases = (customerId) => customersAPI('GET', `/${customerId}/related-cases`);
export const getUsedTags = () => customersAPI('GET', `/tags/used`);
export const getMergeableCases = (creditorId, referenceIds, caseType) => customersAPI('POST', `/mergeable-cases`, {
    body: {
        creditorId,
        referenceIds,
        caseType,
    },
});
export const addUser = (customerId, newUser) => customersAPI('POST', `/${customerId}/users`, {
    body: newUser,
});
export const deleteUser = (customerId, userId) => customersAPI('DELETE', `/${customerId}/users/${userId}`, {});
export const getRawAks = (customerId, userId) => customersAPI('GET', `/${customerId}/raw-aks/${userId}`);
//# sourceMappingURL=customers.js.map